import React from "react";
import GenerateNominaModal from "src/components/general/GenerateNominaModal";

/**
 * Wrapper component para mantener compatibilidad con el código existente
 * Usa el componente compartido GenerateNominaModal en modo "cashflow"
 */
export default function CreateNominaFromCashflow({
  selectedDocuments,
  companyId,
  onClose,
  open,
  initialMode = "new"
}) {
  return (
    <GenerateNominaModal
      companyId={companyId}
      mode="cashflow"
      selectedDocuments={selectedDocuments}
      open={open}
      onClose={onClose}
      initialMode={initialMode}
      title="Crear Nómina desde Flujo de Caja"
    />
  );
}
